import { createStore } from "vuex";
import {ICategoryInfo } from "Vue/interfaces/Interfaces";
import {
	productFilteringRequest,
	productFilteringResponse,
	variantGrouping
} from "Vue/interfaces/ProductFilteringInterfaces";
import { wishlistRequest } from "Vue/interfaces/WishlistInterfaces";

export default createStore({
	state: {
		isLoading: true,
		sortByOptions: [
			{
				id: 0,
				value: 'DisplayNameAsc',
				friendlyName: 'Name A-Z'
			},
			{
				id: 1,
				value: 'DisplayNameDesc',
				friendlyName: 'Name Z-A'
			},
			{
				id: 2,
				value: 'New',
				friendlyName: 'Newest'
			},
			{
				id: 3,
				value: 'Featured',
				friendlyName: 'Featured'
			}
		],
		categoryInfo: {
			title: "",
			description: "",
			slug: "",
			productSlug: ""
		} as ICategoryInfo,
		queryStringParams: null,
		responseDataProducts: [] as variantGrouping[],
		responseData: {
			paging: {
				pageNumber: 1,
				resultsPerPage: 24,
				totalPages: 0,
				totalProducts: 0
			}
		} as productFilteringResponse,
		responseRequest: {
			category: "",
			productSlug: "",
			filterOptions: {
				sort: "DisplayNameAsc"
			},
		} as productFilteringRequest,
		comparisonItems: [] as variantGrouping[],
		wishlistRequest:{
			slugs: null
		} as wishlistRequest
	},
	mutations: {
		setResponseRequest(state, data){
			state.responseRequest = data;
		},
		setCategoryInfo(state, data:HTMLElement) {
			state.categoryInfo.title = data.getAttribute('data-product-category');
			state.categoryInfo.description = data.getAttribute('data-product-description');
			state.categoryInfo.slug = data.getAttribute('data-category-slug');
			state.categoryInfo.productSlug = data.getAttribute('data-product-slug');
		},
		updateResponseRequestFilters(state, data) {
			state.responseRequest.filters = data;
		},
		updateResponseDataFilters(state, data) {
			state.responseData.filters = data;
		},
		setProductResponseData(state, data) {
			state.responseDataProducts = data;
		},
		setIsLoading(state, data) {
			state.isLoading = data;
		},
		setResponseData(state, data) {
			state.responseData = data;
		},
		setQueryStringParamsFromUrl(state, data) {
			state.queryStringParams = data;
		},
		cancelComparison(state, data) {
			state.comparisonItems = data;
		},
		updateComparisonItems(state, data) {
			state.comparisonItems = data;
		},
		addProductToComparison(state, data) {
			state.comparisonItems.push(data);
		},
		removeProductFromComparison(state, data) {
			state.comparisonItems.splice(data, 1);
		}
	},
	getters: {
		sortByOptions (state) {
			return state.sortByOptions;
		},
		sortBy (state) {
			return state.responseRequest.filterOptions.sort;
		},
		resultsPerPage (state) {
			return state.responseData.paging.resultsPerPage;
		},
		pageNumber (state) {
			return state.responseData.paging.pageNumber;
		},
		totalPages (state) {
			return state.responseData.paging.totalPages;
		},
		totalProducts (state) {
			return state.responseData.paging.totalProducts;
		},
		responseRequest (state) {
			return state.responseRequest;
		},
		categoryTitle (state) {
			return state.categoryInfo.title;
		},
		responseDataFilters (state) {
			return state.responseData.filters;
		},
		categoryDescription (state) {
			return state.categoryInfo.description;
		},
		categorySlug (state) {
			return state.categoryInfo.slug;
		},
		productSlug (state) {
			return state.categoryInfo.productSlug;
		},
		productResponseData(state) {
			return state.responseDataProducts;
		},
		responseDataPaging(state) {
			return state.responseData.paging;
		},
		comparisonItems(state) {
			return state.comparisonItems;
		},
		wishlistRequest (state) {
			return state.wishlistRequest;
		}
	},
	modules: {},
});
